export function upFirst(str){
    return str.slice(0, 1).toUpperCase() + str.slice(1)
}

export function lowerFirst(str){
    if(str.toUpperCase() == str){
        return str.toLowerCase()
    }
    return str.slice(0, 1).toLowerCase() + str.slice(1)
}